import React from 'react';

interface GradientTextProps {
  children: React.ReactNode;
  className?: string;
}

/*
 * Headings are plain navy (owner-approved polish, 25 Oct 2026: "plain dark headings instead of
 * gradient text"). The name stays so the many call sites need not change.
 */
const GradientText = ({ children, className }: GradientTextProps) => (
    <span className={`text-brand-navy ${className || ''}`}>
        {children}
    </span>
);

export default GradientText;
